import React, { useState } from 'react'
import { IconButton, Toaster } from '@ui'
import { Dialog } from '@ui'
import { NewFloorForm } from './FloorForm'

interface NewFloorDialogProps {
  isOpen: boolean | undefined
  onSuccess: (floor: any, shouldCallback?: boolean) => void
  buildingId: string
  reload: () => void
  onClose: () => void
}

export default function NewFloorDialog({
  isOpen,
  onSuccess,
  buildingId,
  reload,
  onClose,
}: NewFloorDialogProps) {
  const [dirty, setDirty] = useState(false)

  return (
    <Dialog
      style={{ width: 800 }}
      canEscapeKeyClose={false}
      canOutsideClickClose={!dirty}
      title="New Floor"
      usePortal
      isOpen={isOpen}
      transitionDuration={200}
      isCloseButtonShown={false}
      toolbar={
        !dirty ? (
          <div className="dialog-buttons">
            <IconButton minimal tooltip="Close" iconName="times" onClick={onClose} />
          </div>
        ) : (
          <></>
        )
      }
      body={
        <NewFloorForm
          dirty={dirty}
          setDirty={setDirty}
          onCancel={() => {
            setDirty(false)
            onClose()
          }}
          onSuccess={(floor, shouldCallback) => {
            setDirty(false)
            onSuccess(floor, shouldCallback)
            Toaster.success({ message: 'Floor created' })
          }}
          buildingId={buildingId}
          reload={reload}
          onClose={onClose}
        />
      }
    />
  )
}
